export const BFF_COOKIE_HEADER = 'X-Account-Logged-In-User';
export const YETTEL_ACCOUNT_COOKIE = 'account-logged-in-user';
export const X_MOCK_API = 'x-mock-api';
export const SEC_FETCH_MODE = 'sec-fetch-mode';
